import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '@material-ui/icons/Close';
import Button from '$components/Button';

import { StyledBanner } from './Banner.styled';

const Banner = ({ children }) => {
  const [showBanner, setShowBanner] = useState(true);

  if (!showBanner) {
    return null;
  }

  return (
    <StyledBanner role="banner">
      {children}
      <Button
        size="iconMedium"
        look="iconTransparentCircle"
        label="Close banner"
        onClick={() => setShowBanner(false)}
      >
        <CloseIcon />
      </Button>
    </StyledBanner>
  );
};

Banner.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Banner;
